export default class DesignNavigationItem {
  /**
   *
   * @type {string}
   */
  text = '';

  /**
   *
   * @type {featureInterface}
   */
  part = null;

  /**
   *
   * @type {boolean}
   */
  matchesMetaFailed = false;

  /**
   *
   * @type {[featureInterface]}
   */
  colorOptions = null;

  constructor(text, feature, colorOptions = null) {
    this.text = text;
    this.part = feature;
    this.matchesMetaFailed = feature.matchesMetaFailed || false;
    this.colorOptions = colorOptions;
    // this.matchesMetaFailedArray = part.matchesMetaFailedArray || null
  }
}
